export default __webpack_public_path__ + "static/media/eye.b6c69034.svg";